export enum PaymentError {
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
